import { SORTING_DIR } from "@/common/models";
import { ITableConfig } from "@/components/table/table.model";

export const table_config: ITableConfig = {
  columns: [
    {
      name: "Name",
      key: "name",
      spanMin: "17rem",
      spanMax: "1fr",
      sortable: false,
      filterable: false,
      jsPath: "$[*].name",
    },
    {
      name: "Department",
      key: "department",
      spanMin: "14rem",
      spanMax: "1fr",
      sortable: false,
      filterable: false,
      sortDir: SORTING_DIR.ASC,
      isSortActive: false,
      jsPath: "$[*].department",
    },
    {
      name: "Risk Score",
      key: "score",
      spanMin: "10rem",
      spanMax: "14rem",
      sortable: false,
      filterable: false,
      sortDir: SORTING_DIR.ASC,
      isSortActive: false,
      jsPath: "$[*].score",
    },
    {
      name: "Show Events",
      key: "events",
      spanMin: "8rem",
      spanMax: "8rem",
      sortable: false,
      filterable: false,
      sortDir: SORTING_DIR.ASC,
      isSortActive: false,
    },

    {
      name: "Investigate User",
      key: "",
      spanMin: "10rem",
      spanMax: "10rem",
      sortable: false,
      filterable: false,
      sortDir: SORTING_DIR.ASC,
      isSortActive: false,
    },

    {
      name: "Manage Trust",
      key: "isTrusted",
      spanMin: "10rem",
      spanMax: "10rem",
      sortable: false,
      filterable: false,
      sortDir: SORTING_DIR.ASC,
      isSortActive: false,
      jsPath: "$[*].score",
    },
  ],
};
